import { types } from "../../types/types";

const initialState = {
  items: [],
  cargada: false,
  loading: false,
  observacion: null,
  error: null,
};

export const propuestaFacturacionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.propuestaFacturacionTraerStart:
          return {
            ...state,
            loading: true,
            error: null,
            cargada: false,
          };
        case types.propuestaFacturacionTraerSuccess:
          return {
            ...state,
            loading: false,
            items: action.payload,
            cargada: true,
          };
        case types.propuestaFacturacionTraerError:
          return {
            ...state,
            loading: false,
            error: action.payload,
            items: [],
            cargada: false,
          };
        case types.propuestaFacturacionLimpiar:
          return {
            ...state,
            loading: false,
            items: [],
            cargada: false,
          };
        case types.propuestaFacturacionModificar:
          console.log(state.items);

          state.items.forEach(element => {
            if(element.cuil === action.payload.cuil)
            console.log("Hay coincidencia en " + action.payload.cuil);
          });

          return {
            ...state,
            loading: false,
            items: state.items.map( item => 
              item.cuil === action.payload.cuil
              ? {...action.payload}
              : item
            )
          };
        case types.propuestaFacturacionEliminar:
          return {
            ...state,
            loading: false,
            items: state.items.filter( ( el ) => !action.payload.includes( el ) )
          }
        case types.observacionFacturacionTraerStart:
          return {
            ...state,
            loading: true,
            error: null,
            cargada: false,
          };
        case types.observacionFacturacionTraerSuccess:
          return {
            ...state,
            loading: false,
            observacion: action.payload,
            cargada: true,
          };
        case types.observacionFacturacionTraerError:
          return {
            ...state,
            loading: false,
            error: action.payload,
            items: [],
            observacion: null,
            cargada: false,
          };
        case types.observacionFacturacionLimpiar:
          return {
            ...state,
            loading: false,
            observacion: null,
            cargada: false,
            error: null,
          };
        default:
          return state;
      }
    };
    